import React from "react";

const MAP = {
  available: { label: { fr: "Disponible", en: "Available" }, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  sold: { label: { fr: "Vendu", en: "Sold" }, cls: "bg-red-600 text-white border-red-700" },
  rented: { label: { fr: "Loué", en: "Rented" }, cls: "bg-violet-600 text-white border-violet-700" },
  negotiation: { label: { fr: "En cours de négociation", en: "Negotiating" }, cls: "bg-amber-50 text-amber-800 border-amber-200" },
  reserved: { label: { fr: "Réservé", en: "Reserved" }, cls: "bg-blue-600 text-white border-blue-700" },
  pending: { label: { fr: "Réservé", en: "Reserved" }, cls: "bg-blue-600 text-white border-blue-700" },
  inactive: { label: { fr: "Désactivé", en: "Inactive" }, cls: "bg-slate-700 text-white border-slate-800" },
  new: { label: { fr: "Nouveau", en: "New" }, cls: "bg-brand-orangeSoft text-brand-orangeDark border-orange-200" },
  urgent: { label: { fr: "Urgent", en: "Urgent" }, cls: "bg-red-50 text-red-700 border-red-200" },
  price_drop: { label: { fr: "Baisse de prix", en: "Price drop" }, cls: "bg-lime-50 text-lime-700 border-lime-200" },
  featured: { label: { fr: "Coup de cœur", en: "Featured" }, cls: "bg-brand-navy text-white border-brand-navy" },
};

export default function StatusBadge({ status, lang = "fr", className = "" }) {
  const cfg = MAP[status];
  if (!cfg) return null;
  return (
    <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full border ${cfg.cls} ${className}`}>
      {cfg.label[lang] || cfg.label.fr}
    </span>
  );
}
